module.exports = __webpack_public_path__ + "media/images/serviettes fournies-5090b10a7eb5c91f0722ed9ca610b4f3.svg";